module.exports = __webpack_public_path__ + "img/DE00469.131b47b1.png";